import { render, staticRenderFns } from "./UserBlurb.vue?vue&type=template&id=baf58ce2&scoped=true&"
import script from "./UserBlurb.vue?vue&type=script&lang=js&"
export * from "./UserBlurb.vue?vue&type=script&lang=js&"
import style0 from "./UserBlurb.vue?vue&type=style&index=0&id=baf58ce2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf58ce2",
  null
  
)

export default component.exports